import { accordionSummaryClasses, type Components } from '@mui/material';
import { themeVars } from '../themeVars';
import { typographyStyles, type Theme } from './utils';

export const MuiAccordion: Components<Theme>['MuiAccordion'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      boxShadow: 'none',
      backgroundColor: 'transparent',
      backgroundClip: 'padding-box',
      '&::before': {
        display: 'none',
      },
      '& + &': {
        borderTop: '1px solid',
        borderTopColor: themeVars(theme).palette.border.subtle,
      },
    }),
  },
};

export const MuiAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
      }),
      '&:hover': {
        backgroundColor: themeVars(theme).palette.action.hover,
      },
      [`&:focus-visible`]: {
        backgroundColor: 'transparent',
        boxShadow: `inset 0 0 0 2px ${themeVars(theme).palette.border.focused}`,
      },
      [`& .${accordionSummaryClasses.content}`]: {
        marginRight: theme.spacing(1),
        marignBlock: theme.spacing(2),
      },
    }),
    content: ({ theme }) => ({
      ...typographyStyles(theme.typography.body1),
      flexDirection: 'column',
    }),
    expandIconWrapper: ({ theme }) => ({
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.short,
      }),
      transform: 'scaleY(1)',
      [`&.${accordionSummaryClasses.expanded}`]: {
        transform: 'scaleY(-1)',
      },
    }),
  },
};
